import React from 'react';

import { cn } from '@lyearn/style';
import * as BaseCard from '@/modules/content/components/ContentCard/BaseCard';
import { COMMON_CARD_CLASSNAME } from '@/modules/content/components/ContentCard/styles';

import { grayscaleStyles, wideCardSizeStyles } from './styles';

const BOOKMARK_CLASSES = {
  icon: {
    notBookmarked: 'opacity-0 xs:opacity-100 text-icon-placeholder group-hover:opacity-100',
  },
};

const BOOKMARK_TOOLTIP_PROPS = {
  placement: 'right' as const,
};

const WideCard: React.FC<
  BaseCard.BaseCardProps & { hideBookmark?: boolean; classes?: { size?: string } }
> = (props) => {
  const {
    children,
    content,
    className,
    classes,
    disabled = false,
    hideBookmark = false,
    ...rest
  } = props;

  return (
    <BaseCard.Provider
      className={cn(
        cn(COMMON_CARD_CLASSNAME),
        { 'hover:shadow-02': !disabled },
        { [grayscaleStyles]: disabled },
        className,
        classes?.size ?? wideCardSizeStyles,
      )}
      content={content}
      disabled={disabled}
      {...rest}>
      {!disabled && !hideBookmark ? (
        <BaseCard.Bookmark
          appearance="primary"
          classes={BOOKMARK_CLASSES}
          tooltipProps={BOOKMARK_TOOLTIP_PROPS}
        />
      ) : null}
      {children}
    </BaseCard.Provider>
  );
};

export default WideCard;
